import { Injectable } from '@angular/core';
import { ProductPricesModel } from '@libs/shop/models';

@Injectable({ providedIn: 'root' })
export class ProductPriceVisibilityService {
  public arePricesVisible(productPrices: ProductPricesModel | undefined): boolean {
    return !!productPrices && !productPrices.redacted;
  }
}
